import type * as z from 'zod/mini';

import type { StorageKeySchema } from '../storage.types';

export const createStorageKeySchema = <T>(params: {
  key: string;
  schema: z.ZodMiniType<T>;
}): StorageKeySchema<T> => {
  return params;
};
